import { getCookie } from '@/utils/cookies';

export function addUtm(baseUrl) {
    let utmUuid = getCookie('corporate-uuid');

    if (!utmUuid) return baseUrl;

    const url = new URL(baseUrl, window.location.origin);
    url.searchParams.set('utm_uuid', utmUuid);

    return url.pathname + url.search;
}